import * as React from 'react';

import { routes } from 'defs';
import noop from 'helper/noop';

import ButtonBar from 'components/molecules/ButtonBar';
import Summary from 'components/molecules/Summary';
import { AnamnesisStepResolver } from 'components/organisms/Anamnesis';
import { RouteType } from 'defs/routes';
import { actionCreators } from 'store/profile/profile.actionCreators';

interface ISummary {
	title: string;
	elements: {
		label: string;
		value: string;
		icon: string;
		_target: RouteType;
	}[];
}

export type VerifyProps = {
	onNavigationClick: (targetUrl: { href: string }) => void /* parent */;
	onStepCompleted: (resolver: AnamnesisStepResolver) => void /* parent */;
	onFinishAnamnesis: (targetUrl: { href: string }) => void;
	doFinish: typeof actionCreators.doFinish;
	isUpdatingAnamnesis: boolean;
	personalSummary: ISummary;
	targetSummary: ISummary;
	dietaryHabitsSummary: ISummary;
	buttons?: {
		link: {
			modifier: string;
			title: string;
			openInNewWindow: boolean;
			iconRight: string;
		};
	}[];
	location?: {
		search?: string;
	};
	router: {
		push: Function;
	};
};

type RouteEditFactory = {
	id: string;
	href: string;
};

/*
 * Anamnesis - Verify Step
 * @extends {Component}
 * @requires {Summary}
 * @requires {ButtonBar}
 */
export default class Verify extends React.Component<VerifyProps> {
	public static displayName = 'AnamnesisVerify';
	public static defaultProps = {
		personalSummary: {},
		targetSummary: {},
		onNavigationClick: noop,
		onStepCompleted: noop,
		onFinishAnamnesis: noop,
		doFinish: noop,
	};

	get nextStepUrl(): string {
		let url = routes.anamnesis.dsgvo.href;
		const location = this.props.location;

		if (location && typeof location.search === 'string') {
			url += location.search;
		}

		return url;
	}

	/*
	 * Show Disclaimer if pressed on the Button
	 */
	public onFinish = () => {
		this.props.router.push(this.nextStepUrl);
	};

	/*
	 * Redirect to a step based on the ID of a route set in summary container
	 * @param  {string} key         Route ID
	 */
	public handleEditDelegate = (key: string) => {
		const mapIdToRoute = {};

		// tslint:disable-next-line: forin
		for (const factoryKey in routes.anamnesis) {
			const factory: RouteEditFactory = routes.anamnesis[factoryKey];
			mapIdToRoute[factory.id] = factory.href;
		}

		const redirectTo = mapIdToRoute[key];

		if (redirectTo) {
			this.props.router.push(redirectTo);
		}
	};

	public render() {
		const { personalSummary, targetSummary, dietaryHabitsSummary, buttons, isUpdatingAnamnesis } = this.props;

		return (
			<div>
				<Summary {...personalSummary} onEdit={this.handleEditDelegate} />
				<Summary {...targetSummary} onEdit={this.handleEditDelegate} />
				<Summary {...dietaryHabitsSummary} onEdit={this.handleEditDelegate} />
				{buttons && (
					<div className="o-anamnesis__button-bar">
						<ButtonBar buttons={buttons} loading={isUpdatingAnamnesis} handleButtonClicks={this.onFinish} />
					</div>
				)}
			</div>
		);
	}
}
